import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";

import ShipmentEnquiryTable from "../../components/ShipmentEnquiry/ShipmentEnquiryTable";
import AddFollowUp from "../../components/ShipmentEnquiry/AddFollowUp";



const AddFollowUpPage = () => {
    return (
        <>

            <MasterLayout>

                <Breadcrumb title="Add Follow Up" />


                <AddFollowUp />




            </MasterLayout>
        </>
    );
};

export default AddFollowUpPage;
